<template>
  <!-- El span da al textarea de copia un contenedor dentro del diálogo, si lo hay (ver copyToClipboard) -->
  <span class="copy-access-link">
    <v-btn
      v-if="icon"
      :aria-label="label"
      :color="color"
      :loading="loading"
      :title="label"
      icon
      small
      test-id="copy-access-link-button"
      @click="copy"
    >
      <v-icon size="20">{{ copied ? "mdi-check" : "mdi-content-copy" }}</v-icon>
    </v-btn>

    <v-btn
      v-else
      :color="color"
      :loading="loading"
      class="text-none"
      small
      test-id="copy-access-link-button"
      text
      @click="copy"
    >
      <v-icon v-if="copied" left small>mdi-check</v-icon>
      {{ label }}
    </v-btn>
  </span>
</template>

<script>
import { copyToClipboard } from "@/plugins/helpers";

// La copia es instantánea: el loading se mantiene un instante para que el usuario perciba la acción
const LOADING_MS = 500;
// Tiempo que se muestra la confirmación de enlace copiado
const COPIED_FEEDBACK_MS = 3000;

export default {
  name: "CopyAccessLinkButton",
  props: {
    url: String,
    // Botón de icono (filas de intervinientes); por defecto, enlace de texto (diálogos y QR inline)
    icon: Boolean
  },
  data() {
    return {
      loading: false,
      copied: false,
      timeout: null
    };
  },
  computed: {
    label() {
      return this.$vuetify.lang.t(this.copied ? "$vuetify.linkCopied" : "$vuetify.copyUrlToClipboard");
    },
    color() {
      return this.copied ? "var(--success)" : "var(--primary)";
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeout);
  },
  methods: {
    async copy() {
      clearTimeout(this.timeout);
      this.copied = false;
      this.loading = true;

      const copied = await copyToClipboard(this.url, this.$el);

      this.timeout = setTimeout(() => {
        this.loading = false;

        if (copied) {
          this.copied = true;
          this.timeout = setTimeout(() => {
            this.copied = false;
          }, COPIED_FEEDBACK_MS);
        }
      }, LOADING_MS);
    }
  }
};
</script>
